
export class Staff {
    public Id: number = 0;
    public FirstName: string = '';
    public LastName: string = '';
    public Email = '';
    public BranchId?: number = null;
    public Description = '';
    public IsOperator: boolean = false;
    public Username: string = '';
    public Password: string = '';
    public UserId: string = '';
    public CreatedBy?: number;
    public CreationDate: Date = new Date();
    public CreatorName: string;
    public SubscriberId: number;
    public IDSSN: string = null;
    public StaffCode: string = null;
    public HireDate?: any = null;
    public LaborRate?: number = null;
    public LicenceNumber: string = null;
    public LicenceIssueDate?: any = null;
    public LicenceExpiryDate?: any = null;
    public InsuranceNumber: string = null;
    public InsuranceBy: string = null;
    public InsuranceIssueDate?: any = null;
    public IButton: string = "";
    public RFId: string = "";
    public StaffOrganizations: StaffOrganization[] = [];
    public IsActive: boolean;
    public IsAdmin: boolean;
    public PermittedBranchIds: number[] = [];
    StaffAttachment: any[];
    public ProfilePictureId?: number = null;
    LanguageId?: number = null;
    ResourceDeliveryTypeId: number = 1;
    ThreePLServiceProviderId: number ;
    Mobile: any;
    StaffTypeId: number = null;
    StaffManagerId: number = null;
}

export class StaffOrganization {

    public Id: number;
    public StaffId: number;
    public OrganizationId: number;
    public IsDeleted: boolean;
}


// WEBPACK FOOTER //
// D:/TFS/Softec.FMS-Core-Live/Source/Frontend/Web/Softec.FMS.Client.WebView-ng4/app/shared/dataModels/staff.ts